import React, { FC, useCallback } from 'react';
import PublicLayout from '@/Components/layouts/ResponsivePublicLayout';
import ProductPath from './Components/ProductPath';
import Main from './Components/Main';
import { useGetProductDetailId } from './Hooks/useGetProductDetail';
import { YMaps } from 'react-yandex-maps';
import { ProductDetailServerStateProvider } from './Context/ServerState';
import { IInitialServerProductDetail } from './Context/ServerState/actions/getInitialProductDetail';
import ProductDetailHeader from './Components/MobileComponents/Header';
import { useIsMobile } from '@/Hooks/useIsMobile';
import { useIsAuth } from '@/Hooks/useIsAuth';
import { useContextSelector } from 'use-context-selector';
import { AuthContext } from '@/Context/Auth';

const MakeComplainModal = React.lazy(() => import('@/Components/moleculas/MakeComplain/MakeComplainModal'));

type IProductDetailProps = {
  initialData: IInitialServerProductDetail;
}

const ProductDetail: FC<IProductDetailProps> = ({ initialData }) => {
  const isMobile = useIsMobile();
  const isAuth = useIsAuth();
  const showAuthModal = useContextSelector(AuthContext, (v) => v.actions.showModal);
  const id = useGetProductDetailId();

  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const openComplainModal = useCallback(() => {
    if (!isAuth) {
      showAuthModal();
      return;
    }
    setIsModalOpen(true);
  }, [isAuth]);

  return (
    <YMaps>
      <ProductDetailServerStateProvider initialValue={initialData}>
        <PublicLayout>
          {!isMobile && <ProductPath />}
          {isMobile && <ProductDetailHeader openComplainModal={openComplainModal} />}
          <Main key={id} openComplainModal={openComplainModal} />
        </PublicLayout>
        <MakeComplainModal
          productId={id}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </ProductDetailServerStateProvider>
    </YMaps>
  )
}

export default ProductDetail;
